<template>
  <div>
    <b-row class="d-flex flex-wrap align-items-center">
      <b-col v-if="question.image != 0" class="text-center">
        <b-img-lazy thumbnail :src="cdnUrl + question.image" width="256"></b-img-lazy>
      </b-col>
      <b-col class="text-center">
        <b-row>
          <template v-if="editable">
            <b-col
              :md="12 / question.answers.length"
              v-for="(answer, indexAnswer) in question.answers"
              :key="answer.id"
            >
              <b-button
                pill
                variant="outline-secondary"
                :class="'mx-1 btn__exam' + ((isSelected === answer.id) ? ' btn__exam--selected' : '')"
                @click="selectAnswer(answer.id)"
              >
                <span>{{ (indexAnswer + 1 + 9).toString(36).toUpperCase() }}. </span>
                <span v-if="answer.content" v-html="answer.content"></span>
              </b-button>

              <b-img-lazy thumbnail v-if="answer.attachment_image != 0" :src="cdnUrl + answer.attachment_image" width="256"></b-img-lazy>
            </b-col>
          </template>
          <template v-else>
            <b-col
              :md="12 / question.answers.length"
              v-for="(answer, indexAnswer) in question.answers"
              :key="answer.id"
            >
              <template v-if="answer.is_answer">
                <b-button
                  pill
                  variant="outline-secondary"
                  :class="'mx-1 btn__exam btn__exam--right'"
                >
                  <span>{{ (indexAnswer + 1 + 9).toString(36).toUpperCase() }}. </span>
                  <span v-if="answer.content" v-html="answer.content"></span>
                </b-button>
              </template>
              <template v-else>
                <b-button
                  pill
                  variant="outline-secondary"
                  :class="'mx-1 btn__exam' + ((response.answer_id === answer.id) ? ' btn__exam--exam_no' : '')"
                >
                  <span>{{ (indexAnswer + 1 + 9).toString(36).toUpperCase() }}. </span>
                  <span v-if="answer.content" v-html="answer.content"></span>
                </b-button>
              </template>

              <b-img-lazy thumbnail v-if="answer.attachment_image != 0" :src="cdnUrl + answer.attachment_image" width="256"></b-img-lazy>
            </b-col>
          </template>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionListeningImage',
  props: {
    question: Object,
    editable: Boolean,
    response: Object
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
      isSelected: false
    }
  },
  methods: {
    selectAnswer(a_id) {
      this.isSelected = a_id;

      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer_id: a_id
      })
    }
  }
}
</script>